module.exports = __webpack_public_path__ + "img/arrow-left-363.67b7917e.svg";